import useIntersectionObserver from "./useIntersectionObserver";
import ScrambleText from "./ScrambleText";

const SKILLS = [
  {
    title: 'Languages',
    items: [
      { label: 'TypeScript', primary: true },
      { label: 'JavaScript', primary: true },
      { label: 'Python' },
      { label: 'Go' },
      { label: 'HTML' },
      { label: 'CSS' },
    ],
  },
  {
    title: 'Backend',
    items: [
      { label: 'Node.js', primary: true },
      { label: 'Next.js API Routes', primary: true },
      { label: 'SST' },
      { label: 'Django' },
      { label: 'FastAPI' },
      { label: 'REST' },
      { label: 'API Integration' },
      { label: 'gRPC' },
    ],
  },
  {
    title: 'Frontend',
    items: [
      { label: 'Next.js', primary: true },
      { label: 'React', primary: true },
      { label: 'React Native' },
      { label: 'Tailwind CSS' },
    ],
  },
  {
    title: 'AI / ML',
    items: [
      { label: 'AWS Bedrock', primary: true },
      { label: 'RAG', primary: true },
      { label: 'AI Agents' },
      { label: 'LLM Integration' },
      { label: 'Claude' },
      { label: 'MCP' },
      { label: 'Strands Agents' },
      { label: 'TensorFlow' },
    ],
  },
  {
    title: 'Cloud & DevOps',
    items: [
      { label: 'AWS', primary: true },
      { label: 'GitHub Actions' },
      { label: 'Vercel' },
      { label: 'Render' },
      { label: 'CI/CD Pipelines' },
    ],
  },
  {
    title: 'Databases',
    items: [
      { label: 'PostgreSQL', primary: true },
      { label: 'MongoDB' },
      { label: 'MySQL' },
      { label: 'Redis' },
      { label: 'SQLite' },
    ],
  },
  {
    title: 'Testing & Quality',
    items: [
      { label: 'Vitest' },
      { label: 'Playwright' },
      { label: 'Husky' },
      { label: 'Biome' },
    ],
  },
  {
    title: 'Tools & Others',
    items: [
      { label: 'Git' },
      { label: 'Jira' },
      { label: 'Atlassian Forge' },
      { label: 'Aha!' },
      { label: 'Postman' },
    ],
  },
];

const Skills = () => {
  const [ref, isInView] = useIntersectionObserver();

  return (
    <div ref={ref} className={`section-wrap ${isInView ? 'show' : 'hidden'}`} id="skills">
      <div className="section-head">
        <div className="section-eye">What I work with</div>
        <ScrambleText text="Skills & Tools" className="section-title" />
        <div className="section-rule" />
      </div>

      <div className={`skills-outer${isInView ? ' skills-animate' : ''}`}>
        <div className="skills-header">
          <span className="skills-header-label">8 categories · hover to explore</span>
          {['TypeScript', 'AWS Bedrock', 'Next.js'].map((t) => (
            <span key={t} className="s-tag primary" style={{ margin: 0 }}>{t}</span>
          ))}
        </div>
        <div className="skills-grid">
          {SKILLS.map((cat) => (
            <div key={cat.title} className="skill-cell">
              <div className="skill-cell-title">{cat.title}</div>
              <div className="skill-tags">
                {cat.items.map((item, i) => (
                  <span
                    key={item.label}
                    className={`s-tag${item.primary ? ' primary' : ''}`}
                    style={isInView ? { animationDelay: `${0.4 + i * 0.06}s` } : {}}
                  >
                    {item.label}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
